import { Package, Tag, FolderOpen, FileCode, Clock, GitBranch } from 'lucide-react';

interface PluginInfo {
  name: string;
  description: string;
  version: string;
  location: string;
  category?: string;
  license?: string;
  lastUpdated?: string;
}

interface PluginProfileProps {
  plugin: PluginInfo;
}

const PluginProfile = ({ plugin }: PluginProfileProps) => {
  const details = [
    { icon: Package, label: 'Plugin Name', value: plugin.name },
    { icon: FileCode, label: 'Description', value: plugin.description },
    { icon: Tag, label: 'Version', value: plugin.version },
    { icon: FolderOpen, label: 'Location', value: plugin.location, mono: true },
    ...(plugin.category ? [{ icon: GitBranch, label: 'Category', value: plugin.category }] : []),
    ...(plugin.license ? [{ icon: FileCode, label: 'License', value: plugin.license }] : []),
    ...(plugin.lastUpdated
      ? [{ icon: Clock, label: 'Last Updated', value: plugin.lastUpdated }]
      : []),
  ];

  return (
    <div className="card-elevated p-6 animate-slide-up">
      <h3 className="text-lg font-semibold mb-6">Plugin Profile</h3>

      <div className="grid gap-4">
        {details.map((detail, index) => {
          const Icon = detail.icon;
          return (
            <div key={index} className="flex items-start gap-4 p-4 bg-muted/30 rounded-lg">
              <div className="p-2 bg-primary/10 rounded-lg">
                <Icon className="w-5 h-5 text-primary" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-muted-foreground uppercase tracking-wider mb-1">
                  {detail.label}
                </p>
                <p className={`font-medium ${detail.mono ? 'font-mono text-sm break-all' : ''}`}>
                  {detail.value}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PluginProfile;
